const { getDate } = require('./getDate')

/**
 * Visszaadja, az összes dátumot a kezdő és végdátum között.
 * @param {string} start - Kezdő dátum.
 * @param {string} end   - Vég dátu.
 * @returns {string[]} A napok a két dátum között..
 */
module.exports.getDaysBetweenDates = function getDaysBetweenDates (start, end) {
  /** @type {string[]} */
  const dates = []

  const currentDate = new Date(start)
  const endDate = new Date(end)

  while (currentDate.getTime() <= endDate.getTime()) {
    dates.push(getDate(currentDate.toDateString()))
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dates
}
